import { sbFromEnv } from './supabase';

const url = import.meta.env.VITE_SUPABASE_URL!;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY!;
const PRIVATE_BUCKET = (import.meta.env.VITE_STORYBOOKS_PRIVATE_BUCKET || 'storybooks-private').replace(/^\/+|\/+$/g, '');
const PUBLIC_BUCKET = import.meta.env.VITE_STORYBOOKS_PUBLIC_BUCKET || 'storybooks';
const STORYBOOKS_API_URL = import.meta.env.VITE_STORYBOOKS_API_URL || '';

export const supabase = sbFromEnv({
  url,
  key: anon,
  options: {
    auth: { persistSession: true, autoRefreshToken: true },
  },
});

export async function getSignedImageUrl(key: string, expiresIn = 600) {
  if (!key) return null;

  const normalizedKey = key.replace(/^\/+/, '');
  const path = normalizedKey.startsWith(`${PRIVATE_BUCKET}/`)
    ? normalizedKey
    : `${PRIVATE_BUCKET}/${normalizedKey}`;

  const params = new URLSearchParams({ path, expires: String(expiresIn) });
  const {
    data: { session },
  } = await supabase.auth.getSession();

  const headers: Record<string, string> = { accept: 'application/json' };
  if (session?.access_token) {
    headers.authorization = `Bearer ${session.access_token}`;
  }

  const baseUrl = `${STORYBOOKS_API_URL}/api/storage/signed-url`;

  const response = await fetch(`${baseUrl}?${params.toString()}`, {
    method: 'GET',
    headers,
  });

  const text = await response.text();
  let payload: any = null;
  try {
    payload = text ? JSON.parse(text) : null;
  } catch {
    payload = null;
  }

  if (!response.ok) {
    const message = payload?.error || `HTTP ${response.status}`;
    throw new Error(message);
  }

  return payload?.data?.signed_url ?? payload?.data?.signedUrl ?? payload?.signed_url ?? payload?.signedUrl ?? null;
}

export function getPublicImageUrl(key: string) {
  if (!key) return null;
  const { data } = supabase.storage.from(PUBLIC_BUCKET).getPublicUrl(key);
  return data?.publicUrl ?? null;
}

// Backwards compatibility for older imports.
export async function getSignedUrl(path: string, expires = 3600) {
  return getSignedImageUrl(path, expires);
}
